import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { LocalStorage } from '../../../utilities/localStorage';
import { Errors } from '../../errors';
import { getMe } from '../../user/getMe/getMe.slice';
import getSession from '../../user/session/getSession';
import subCompanySelectRequest from './subCompanySelect.repository';

type InitialState = {
  loading: boolean;
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  error: undefined,
};

export const subCompanySelect = createAsyncThunk(
  'subCompanySelect',
  async (businessPartnerId: string, { dispatch }) => {
    // 204; cerez yeni sirket baglamiyla uzerine yazildi.
    await subCompanySelectRequest(businessPartnerId);
    const session = await getSession();
    LocalStorage.set(LocalStorage.session, JSON.stringify(session));
    dispatch(getMe());
  }
);

const subCompanySelectSlice = createSlice({
  name: 'subCompanySelect',
  initialState,
  reducers: {
    subCompanySelectReset: (state) => {
      state.loading = false;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(subCompanySelect.pending, (state) => {
      state.loading = true;
      state.error = undefined;
    });
    builder.addCase(subCompanySelect.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(subCompanySelect.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default subCompanySelectSlice.reducer;
export const { subCompanySelectReset } = subCompanySelectSlice.actions;
